import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPresent = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 11.5C12.0227 10.815 12.3163 10.167 12.8163 9.6983C13.3164 9.22958 13.982 8.97843 14.667 9C18.611 9 20 14 20 14H14.667C13.982 14.0216 13.3164 13.7704 12.8163 13.3017C12.3163 12.833 12.0227 12.185 12 11.5V11.5Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.333 14H20C20 14 21.389 9 25.333 9C26.018 8.97843 26.6836 9.22958 27.1837 9.6983C27.6837 10.167 27.9773 10.815 28 11.5C27.9773 12.185 27.6837 12.833 27.1837 13.3017C26.6836 13.7704 26.018 14.0216 25.333 14Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29 21V29C29 29.5304 28.7893 30.0391 28.4142 30.4142C28.0391 30.7893 27.5304 31 27 31H13C12.4696 31 11.9609 30.7893 11.5858 30.4142C11.2107 30.0391 11 29.5304 11 29V21",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 14H9V18H31V14Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 14V31",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgPresent);
export default ForwardRef;
